import url from '../url'
import headers from '../headers'

export default {
	getAll (context, user_uid, watch_id, type_id, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/readingtypes/${type_id}/alert_parameters/?size=${size}`,
			headers.bearer()
		)
	},
	get (context, user_uid, watch_id, type_id, id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/readingtypes/${type_id}/alert_parameters/${id}/`,
			headers.bearer()
		)
	},
	add (context, user_uid, watch_id, type_id, model) {
		return context.$http.post(
			`${url}/users/${user_uid}/watches/${watch_id}/readingtypes/${type_id}/alert_parameters/`,
			model,
			headers.bearer()
		)
	},
	edit (context, user_uid, watch_id, type_id, model) {
		return context.$http.put(
			`${url}/users/${user_uid}/watches/${watch_id}/readingtypes/${type_id}/alert_parameters/${model.id}/`,
			model,
			headers.bearer()
		)
	},
	delete (context, user_uid, watch_id, type_id, id) {
		return context.$http.delete(
			`${url}/users/${user_uid}/watches/${watch_id}/readingtypes/${type_id}/alert_parameters/${id}/`,
			headers.bearer()
		)
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/parameters.js